<template>
  <div class="page-container" :class="{ dark: isDarkMode }">
    <ModalLoading :isLoading="cargando" />
    <div class="page-header">
      <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
        <select v-if="esCeo" class="form-select" style="min-width:160px" v-model="filtroSucursal" @change="cargar">
          <option value="">Todas las sucursales</option>
          <option v-for="s in sucursalesCeo" :key="s.id_sucursal" :value="s.id_sucursal">
            {{ s.nombre_administrativo }}
          </option>
        </select>
        <button class="btn-primary" @click="abrirNuevo"><i class="bi bi-plus"></i> Nuevo Arqueo</button>
      </div>
    </div>

    <div class="filters-row">
      <input v-model="busqueda" type="text" class="busqueda" placeholder="Buscar por cajero o auditor…" />
    </div>

    <div v-if="!historialFiltrado.length" class="empty-state">
      <i class="bi bi-cash"></i><p>No hay arqueos registrados.</p>
    </div>

    <div v-else class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th>Período</th>
            <th>Cajero Auditado</th>
            <th>Contado</th>
            <th>Esperado</th>
            <th>Diferencia</th>
            <th>Ventas Efectivo</th>
            <th>Ventas Transf.</th>
            <th>Hecho por</th>
            <th>Fecha</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="a in paginatedArqueos" :key="a.id_arqueo">
            <td data-label="Período">{{ fmtFecha(a.periodo_inicio) }} — {{ fmtFecha(a.periodo_fin) }}</td>
            <td data-label="Cajero">{{ a.Cajero ? a.Cajero.nombre + ' ' + a.Cajero.apellido : '—' }}</td>
            <td data-label="Contado">L. {{ fmtNum(a.total_contado) }}</td>
            <td data-label="Esperado">L. {{ fmtNum(Number(a.monto_apertura || 0) + Number(a.total_ventas_efectivo || 0) - Number(a.total_reembolsos_efectivo || 0)) }}</td>
            <td data-label="Diferencia" :class="a.diferencia < 0 ? 'text-danger' : (a.diferencia > 0 ? 'text-warning' : 'text-success')">
              <strong>L. {{ fmtNum(a.diferencia) }}</strong>
            </td>
            <td data-label="Ef. Ventas">L. {{ fmtNum(a.total_ventas_efectivo) }}</td>
            <td data-label="Transf.">L. {{ fmtNum(a.total_ventas_transferencia) }}</td>
            <td data-label="Hecho por">{{ a.Usuarios ? a.Usuarios.nombre + ' ' + a.Usuarios.apellido : '—' }}</td>
            <td data-label="Fecha">{{ fmtFechaHora(a.created_at) }}</td>
            <td data-label="" class="acciones-cell">
              <button class="accion-btn accion-ver" @click="verDetalle(a)" title="Ver detalle"><i class="bi bi-eye"></i></button>
              <button class="accion-btn accion-reporte" @click="verReporteTurno(a)" title="Reporte de turno"><i class="bi bi-bar-chart-line-fill"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Paginación -->
      <div class="pagination-wrapper">
        <div class="pagination-info">
          Mostrando {{ historialFiltrado.length === 0 ? 0 : (currentPage - 1) * pageSize + 1 }} a
          {{ Math.min(currentPage * pageSize, historialFiltrado.length) }}
          de {{ historialFiltrado.length }} registros
        </div>
        <div class="pagination-container">
          <button class="pagination-button" :disabled="currentPage === 1" @click="currentPage--">Anterior</button>
          <button class="pagination-button" :disabled="currentPage === totalPages" @click="currentPage++">Siguiente</button>
        </div>
      </div>
    </div>

    <!-- Modal nuevo arqueo -->
    <div v-if="modalNuevo" class="modal-overlay">
      <div class="modal-box modal-large">
        <div class="modal-header">
          <h2>Nuevo Arqueo de Caja</h2>
          <button class="btn-close-x" @click="cerrarNuevo"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="modal-body">

          <!-- Cajero selector -->
          <div class="form-group">
            <label>Cajero a auditar <span class="req">*</span></label>
            <select v-model="form.id_cajero" class="form-select" @change="cargarPreview">
              <option :value="null" disabled>— Seleccione un cajero —</option>
              <option v-for="c in cajeros" :key="c.id_usuario" :value="c.id_usuario">
                {{ c.nombre }} {{ c.apellido }}
              </option>
            </select>
            <span v-if="cajeros.length === 0 && !cargandoCajeros" class="hint-text">No hay cajeros registrados en esta sucursal.</span>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Período inicio</label>
              <input v-model="form.periodo_inicio" type="date" class="form-input" @change="cargarPreview" />
            </div>
            <div class="form-group">
              <label>Período fin</label>
              <input v-model="form.periodo_fin" type="date" class="form-input" @change="cargarPreview" />
            </div>
          </div>

          <!-- Sistema preview -->
          <div v-if="preview || cargandoPreview" class="sistema-preview">
            <div v-if="cargandoPreview" class="preview-loading">
              <div class="spinner-sm"></div> Consultando ventas del sistema...
            </div>
            <template v-else-if="preview">
              <div class="preview-title"><i class="bi bi-graph-up"></i> Ventas del Sistema (período seleccionado)</div>
              <div class="preview-grid">
                <div class="preview-item">
                  <span>Efectivo</span>
                  <strong>L. {{ fmtNum(preview.totalEfectivo) }}</strong>
                </div>
                <div class="preview-item">
                  <span>Transferencia</span>
                  <strong>L. {{ fmtNum(preview.totalTransferencia) }}</strong>
                </div>
                <div class="preview-item preview-item--total">
                  <span>Total esperado</span>
                  <strong>L. {{ fmtNum(Number(form.monto_apertura || 0) + Number(preview.totalEfectivo || 0)) }}</strong>
                </div>
              </div>
            </template>
          </div>

          <div class="form-group">
            <label>Monto de Apertura (L.)</label>
            <input v-model.number="form.monto_apertura" type="number" min="0" step="0.01" class="form-input" @input="actualizarTotal" />
          </div>

          <h3 class="denom-title">Conteo de Denominaciones — Honduras (Lempiras)</h3>
          <div class="denominaciones-grid">
            <div class="denom-section">
              <h4><i class="bi bi-bank2"></i> Billetes</h4>
              <div v-for="b in billetes" :key="b.campo" class="denom-row">
                <span class="denom-label">L. {{ b.valor }}</span>
                <input v-model.number="form[b.campo]" type="number" min="0" class="input-denom" @input="actualizarTotal" />
                <span class="denom-sub">= L. {{ fmtNum((form[b.campo]||0) * b.valor) }}</span>
              </div>
            </div>
            <div class="denom-section">
              <h4><i class="bi bi-coin"></i> Monedas</h4>
              <div v-for="m in monedas" :key="m.campo" class="denom-row">
                <span class="denom-label">{{ m.valor >= 1 ? 'L. ' + m.valor : Math.round(m.valor * 100) + '¢' }}</span>
                <input v-model.number="form[m.campo]" type="number" min="0" class="input-denom" @input="actualizarTotal" />
                <span class="denom-sub">= L. {{ fmtNum((form[m.campo]||0) * m.valor) }}</span>
              </div>
            </div>
          </div>

          <div class="total-contado-box">
            <span>Total Contado</span>
            <strong class="total-num">L. {{ fmtNum(totalContado) }}</strong>
          </div>

          <div v-if="preview" class="diferencia-preview" :class="difClass">
            <span>Diferencia vs sistema</span>
            <strong>L. {{ fmtNum(totalContado - Number(form.monto_apertura || 0) - Number(preview.totalEfectivo || 0)) }}</strong>
          </div>

          <div class="form-group" style="margin-top:12px">
            <label>Notas</label>
            <textarea v-model="form.notas" class="form-textarea" rows="2"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="cerrarNuevo">Cancelar</button>
          <button class="btn-guardar-arqueo" @click="guardarArqueo" :disabled="guardando || !form.id_cajero">
            {{ guardando ? 'Guardando...' : 'Registrar Arqueo' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal reporte de turno -->
    <ReporteTurnoModal
      :is-visible="modalReporteTurno"
      :arqueo="arqueoReporte"
      @close="modalReporteTurno = false"
    />

    <!-- Modal detalle -->
    <div v-if="modalDetalle && detActivo" class="modal-overlay">
      <div class="modal-box">
        <div class="modal-header">
          <h2>Detalle de Arqueo</h2>
          <button class="btn-close-x" @click="modalDetalle = false"><i class="bi bi-x-lg"></i></button>
        </div>
        <div class="modal-body">
          <div class="info-row">
            <span>Período: <strong>{{ fmtFecha(detActivo.periodo_inicio) }} — {{ fmtFecha(detActivo.periodo_fin) }}</strong></span>
            <span>Apertura: <strong>L. {{ fmtNum(detActivo.monto_apertura) }}</strong></span>
          </div>
          <div class="info-row" v-if="detActivo.Cajero">
            <span>Cajero auditado: <strong>{{ detActivo.Cajero.nombre }} {{ detActivo.Cajero.apellido }}</strong></span>
            <span>Hecho por: <strong>{{ detActivo.Usuarios ? detActivo.Usuarios.nombre + ' ' + detActivo.Usuarios.apellido : '—' }}</strong></span>
          </div>
          <div class="result-grid">
            <div class="result-card"><span>Ventas Efectivo</span><strong>L. {{ fmtNum(detActivo.total_ventas_efectivo) }}</strong></div>
            <div class="result-card"><span>Ventas Transferencia</span><strong>L. {{ fmtNum(detActivo.total_ventas_transferencia) }}</strong></div>
            <div v-if="Number(detActivo.total_reembolsos_efectivo) > 0" class="result-card card-danger">
              <span>Reembolsos (anulaciones)</span>
              <strong>- L. {{ fmtNum(detActivo.total_reembolsos_efectivo) }}</strong>
            </div>
            <div class="result-card"><span>Total Esperado</span><strong>L. {{ fmtNum(Number(detActivo.monto_apertura||0) + Number(detActivo.total_ventas_efectivo||0) - Number(detActivo.total_reembolsos_efectivo||0)) }}</strong></div>
            <div class="result-card"><span>Total Contado</span><strong>L. {{ fmtNum(detActivo.total_contado) }}</strong></div>
            <div class="result-card" :class="detActivo.diferencia < 0 ? 'card-danger' : (detActivo.diferencia > 0 ? 'card-warning' : 'card-success')">
              <span>Diferencia</span>
              <strong>L. {{ fmtNum(detActivo.diferencia) }}</strong>
            </div>
          </div>
          <template v-if="detActivo.notas">
            <div v-if="notasAdmin(detActivo.notas)" class="notas-box">
              <strong>Notas:</strong> {{ notasAdmin(detActivo.notas) }}
            </div>
            <div v-if="anulacionesArqueo(detActivo.notas).length" class="anulaciones-box">
              <div class="anulaciones-header">
                <i class="bi bi-x-octagon-fill"></i>
                Anulaciones del período ({{ anulacionesArqueo(detActivo.notas).length }})
              </div>
              <table class="anulaciones-table">
                <thead><tr><th>Factura</th><th>Monto</th><th>Motivo</th><th>Hora</th></tr></thead>
                <tbody>
                  <tr v-for="(a, i) in anulacionesArqueo(detActivo.notas)" :key="i">
                    <td class="mono">{{ a[0] }}</td>
                    <td class="mono text-danger">{{ a[1] }}</td>
                    <td>{{ a[2] }}</td>
                    <td class="mono small">{{ a[3] }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { registrarArqueo, getHistorialArqueo, getHistorialArqueoPorSucursal, getCajerosSucursal, getPreviewArqueo } from '../../services/featuresSolicitudes.js';
import ReporteTurnoModal from '../components/ReporteTurnoModal.vue';
import ModalLoading from "@/components/ModalLoading.vue";
import { getSucursalesbyEmmpresaSumm } from '../../services/sucursalesSolicitudes.js';
import { useToast } from 'vue-toastification';
import { setPageTitle } from '@/components/pageMetadata';
const { getSocket } = require('@/services/socket');

const BILLETES = [
  { campo: 'billetes_500', valor: 500 },
  { campo: 'billetes_200', valor: 200 },
  { campo: 'billetes_100', valor: 100 },
  { campo: 'billetes_50',  valor: 50  },
  { campo: 'billetes_20',  valor: 20  },
  { campo: 'monedas_10',   valor: 10  },
];
const MONEDAS = [
  { campo: 'monedas_5',   valor: 5    },
  { campo: 'monedas_2',   valor: 2    },
  { campo: 'monedas_1',   valor: 1    },
  { campo: 'monedas_50c', valor: 0.5  },
  { campo: 'monedas_20c', valor: 0.2  },
  { campo: 'monedas_10c', valor: 0.1  },
  { campo: 'monedas_5c',  valor: 0.05 },
];

const formVacio = (hoy) => ({
  periodo_inicio: hoy, periodo_fin: hoy,
  monto_apertura: 0, notas: '', id_cajero: null,
  billetes_500: 0, billetes_200: 0, billetes_100: 0, billetes_50: 0, billetes_20: 0,
  monedas_10: 0, monedas_5: 0, monedas_2: 0, monedas_1: 0, monedas_50c: 0,
  monedas_20c: 0, monedas_10c: 0, monedas_5c: 0
});

export default {
  name: 'ArqueoCajaPage',
  components: { ReporteTurnoModal, ModalLoading },
  data() {
    const token = localStorage.getItem('auth');
    const hoy = new Date().toISOString().split('T')[0];
    const toast = useToast();
    return {
      toast,
      isDarkMode: localStorage.getItem('isDarkMode') === 'true',
      id_usuario: token ? JSON.parse(atob(token.split('.')[1])).id_usuario : null,
      esCeo: Number(localStorage.getItem('role') || 0) === 4,
      sucursalesCeo: [],
      filtroSucursal: '',
      busqueda: '',
      currentPage: 1,
      pageSize: 10,
      historial: [], cargando: false, guardando: false,
      modalNuevo: false, modalDetalle: false, detActivo: null,
      modalReporteTurno: false, arqueoReporte: null,
      billetes: BILLETES, monedas: MONEDAS,
      cajeros: [], cargandoCajeros: false,
      preview: null, cargandoPreview: false,
      form: formVacio(hoy),
      totalContado: 0,
      hoy,
    };
  },
  computed: {
    paginatedArqueos() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.historialFiltrado.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.historialFiltrado.length / this.pageSize));
    },
    historialFiltrado() {
      const q = this.busqueda.toLowerCase().trim();
      if (!q) return this.historial;
      return this.historial.filter(a => {
        const cajero = a.Cajero ? `${a.Cajero.nombre} ${a.Cajero.apellido}`.toLowerCase() : '';
        const auditor = a.Usuarios ? `${a.Usuarios.nombre} ${a.Usuarios.apellido}`.toLowerCase() : '';
        return cajero.includes(q) || auditor.includes(q);
      });
    },
    difValue() {
      if (!this.preview) return 0;
      return this.totalContado - Number(this.form.monto_apertura || 0) - Number(this.preview?.totalEfectivo || 0);
    },
    difClass() {
      if (this.difValue < 0) return 'dif-danger';
      if (this.difValue > 0) return 'dif-warning';
      return 'dif-success';
    },
  },
  async mounted() {
    setPageTitle('Arqueo de Caja');
    this._darkListener = () => { this.isDarkMode = localStorage.getItem('isDarkMode') === 'true'; };
    window.addEventListener('poswave:toggle-dark', this._darkListener);
    if (this.esCeo) {
      this.sucursalesCeo = await getSucursalesbyEmmpresaSumm(this.id_usuario);
      if (!Array.isArray(this.sucursalesCeo)) this.sucursalesCeo = [];
    }
    await this.cargar();
    const _s = getSocket();
    if (_s) { this._wsRefresh = () => this.cargar(); _s.on('arqueo:refresh', this._wsRefresh); }
  },
  watch: {
    busqueda() { this.currentPage = 1; },
  },
  methods: {
    async cargar() {
      this.cargando = true;
      try {
        if (this.filtroSucursal) {
          this.historial = await getHistorialArqueoPorSucursal(this.filtroSucursal, 20);
        } else {
          this.historial = await getHistorialArqueo(this.id_usuario, 20);
        }
      } catch (e) { console.error(e); } finally { this.cargando = false; }
    },
    async abrirNuevo() {
      this.form = formVacio(this.hoy);
      this.totalContado = 0;
      this.preview = null;
      this.modalNuevo = true;
      this.cargandoCajeros = true;
      try { this.cajeros = await getCajerosSucursal(this.id_usuario); }
      catch (e) { console.error(e); this.cajeros = []; }
      finally { this.cargandoCajeros = false; }
    },
    cerrarNuevo() { this.modalNuevo = false; this.preview = null; },
    actualizarTotal() {
      const allDenom = [...BILLETES, ...MONEDAS];
      this.totalContado = allDenom.reduce((s, d) => s + (Number(this.form[d.campo] || 0) * d.valor), 0);
    },
    async cargarPreview() {
      if (!this.form.id_cajero || !this.form.periodo_inicio || !this.form.periodo_fin) return;
      this.cargandoPreview = true;
      this.preview = null;
      try {
        this.preview = await getPreviewArqueo(
          this.id_usuario,
          this.form.id_cajero,
          this.form.periodo_inicio,
          this.form.periodo_fin
        );
      } catch (e) { console.error(e); }
      finally { this.cargandoPreview = false; }
    },
    async guardarArqueo() {
      if (!this.form.id_cajero) {
        this.toast.warning('Seleccione un cajero a auditar.');
        return;
      }
      this.guardando = true;
      try {
        const res = await registrarArqueo(this.id_usuario, this.form);
        const diff = res.arqueo.diferencia;
        const msg = diff === 0 ? '✅ Cuadre perfecto.' :
          (diff > 0 ? `⚠️ Sobrante: L. ${this.fmtNum(diff)}` : `❌ Faltante: L. ${this.fmtNum(Math.abs(diff))}`);
        this.toast.success(`Arqueo registrado. ${msg}`);
        this.cerrarNuevo();
        await this.cargar();
      } catch (e) { this.toast.error('Error: ' + e.message); } finally { this.guardando = false; }
    },
    verDetalle(a) { this.detActivo = a; this.modalDetalle = true; },
    verReporteTurno(a) { this.arqueoReporte = a; this.modalReporteTurno = true; },
    fmtNum(n) { return Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2 }); },
    fmtFecha(f) { return f ? new Date(f + 'T00:00:00').toLocaleDateString('es-HN') : '—'; },
    fmtFechaHora(f) { return f ? new Date(f).toLocaleString('es-HN') : '—'; },
    notasAdmin(notas) {
      if (!notas) return '';
      const idx = notas.indexOf('\n\n--- Anulaciones del período');
      return idx === -1 ? notas.trim() : notas.slice(0, idx).trim();
    },
    anulacionesArqueo(notas) {
      if (!notas) return [];
      const idx = notas.indexOf('--- Anulaciones del período');
      if (idx === -1) return [];
      return notas.slice(idx).split('\n')
        .filter(l => l.startsWith('•'))
        .map(l => l.slice(2).split(' | ').map(s => s.trim()));
    },
  },
  beforeUnmount() {
    window.removeEventListener('poswave:toggle-dark', this._darkListener);
    const _s = getSocket();
    if (_s && this._wsRefresh) _s.off('arqueo:refresh', this._wsRefresh);
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

* { font-family: "Montserrat", sans-serif; box-sizing: border-box; }

/* ── Page Layout ── */
.page-container { padding: 16px; width: 100%; overflow-x: hidden; background: #ffffff; min-height: 100vh; color: #212529; }
.page-header { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px; margin-bottom: 20px; padding: 0 4px; }
.page-header h1 { font-size: clamp(22px, 4vw, 30px); font-weight: 700; margin: 8px 0; color: #333; }
.subtitle { font-size: 0.875rem; color: #6c757d; margin: 0; }

/* ── Inputs ── */
.filters-row { margin-bottom: 16px; }
.busqueda, .form-input { padding: 8px 12px; font-size: 14px; border-radius: 10px; border: 1px solid #ced4da; outline: none; background: white; color: #212529; transition: all 0.3s ease; }
input:focus, select:focus, textarea:focus { border-color: #c09d62; box-shadow: 0 0 0 3px rgba(192,157,98,0.2); outline: none; }
.form-select, select { padding: 8px 12px; border-radius: 10px; border: 1px solid #ced4da; font-family: "Montserrat", sans-serif; font-size: 14px; cursor: pointer; background: white; color: #212529; width: 100%; }
.form-textarea { width: 100%; padding: 8px 12px; border-radius: 10px; border: 1px solid #ced4da; font-family: "Montserrat", sans-serif; font-size: 14px; resize: vertical; outline: none; background: white; color: #212529; }
.hint-text { font-size: 0.75rem; color: #6c757d; margin-top: 4px; }
.req { color: #dc3545; }

/* ── Buttons ── */
.btn-primary { background-color: #c09d62 !important; color: white !important; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-primary:hover { background-color: #a38655 !important; transform: scale(1.02); }
.btn-primary:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.btn-cancel, .btn-secondary { background-color: #6c757d !important; color: white !important; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-cancel:hover, .btn-secondary:hover { background-color: #5a6268 !important; }
/* Botones de acción en tabla */
.accion-btn { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: none; border-radius: 6px; cursor: pointer; color: #fff; font-size: 0.85rem; margin: 0 2px; transition: opacity 0.15s, transform 0.15s; }
.accion-btn:hover { opacity: .85; transform: scale(1.08); }
.accion-ver     { background: #0e7490; }
.accion-reporte { background: #3b82f6; }

/* Botón guardar en modal */
.btn-guardar-arqueo { background-color: #198754 !important; color: white !important; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-guardar-arqueo:hover { background-color: #146c43 !important; transform: scale(1.02); }
.btn-guardar-arqueo:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.acciones-cell { display: flex; align-items: center; gap: 4px; }
.btn-close-x { background: none; border: none; cursor: pointer; font-size: 1rem; color: #6c757d; padding: 4px; border-radius: 6px; display: flex; align-items: center; }
.btn-close-x:hover { color: #212529; background: #f8f9fa; }

/* ── Loading / Empty ── */
.loading { display: flex; justify-content: center; padding: 3rem; }
.spinner { width: 36px; height: 36px; border: 3px solid #f3f3f3; border-top: 3px solid #c09d62; border-radius: 50%; animation: spin 0.8s linear infinite; }
.spinner-sm { width: 18px; height: 18px; border: 2px solid #e2e8f0; border-top: 2px solid #c09d62; border-radius: 50%; animation: spin 0.8s linear infinite; display: inline-block; vertical-align: middle; }
@keyframes spin { to { transform: rotate(360deg); } }
.empty-state { display: flex; flex-direction: column; align-items: center; padding: 3rem; gap: 12px; color: #6c757d; text-align: center; }
.empty-state i { font-size: 2.5rem; opacity: 0.4; }

/* ── Table ── */
.table-container { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; margin-bottom: 20px; border-radius: 8px; border: 1px solid #e2e8f0; }
.table-container::-webkit-scrollbar { width: 8px; height: 8px; }
.table-container::-webkit-scrollbar-thumb { background: #c09d62; border-radius: 4px; }
.data-table { width: 100%; border-collapse: collapse; font-size: 0.875rem; }
.data-table th { padding: 8px 12px; text-align: left; font-weight: 700; font-size: 0.8rem; border-bottom: 2px solid #dee2e6; background: #f8f9fa; white-space: nowrap; color: #495057; }
.data-table td { padding: 8px 12px; border-bottom: 1px solid #dee2e6; vertical-align: middle; color: #212529; background: white; }
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover td { background-color: #f8f9fa; }

/* ── Text ── */
.text-danger { color: #dc3545 !important; }
.text-warning { color: #856404 !important; }
.text-success { color: #0f5132 !important; }

/* ── Modal ── */
.modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9000; padding: 1rem; }
.modal-box { background: white; border-radius: 12px; box-shadow: 0 8px 32px rgba(0,0,0,0.2); width: 100%; max-width: 600px; max-height: 90vh; display: flex; flex-direction: column; overflow: hidden; }
.modal-large { max-width: 760px; }
.modal-header { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid #dee2e6; background: #f8f9fa; }
.modal-header h2 { font-size: 1rem; font-weight: 700; margin: 0; color: #212529; }
.modal-body { padding: 1.25rem; overflow-y: auto; flex: 1; background: white; }
.modal-footer { padding: 1rem 1.25rem; border-top: 1px solid #dee2e6; display: flex; gap: 8px; justify-content: flex-end; background: #f8f9fa; }

/* ── Forms ── */
.form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 12px; }
.form-group { display: flex; flex-direction: column; gap: 4px; margin-bottom: 12px; }
.form-group label { font-size: 0.8rem; font-weight: 600; color: #495057; }
.form-group .form-input, .form-group .form-select, .form-group textarea { width: 100%; }

/* ── Sistema Preview ── */
.sistema-preview { background: #f0f7ff; border: 1px solid #b8d8f8; border-radius: 10px; padding: 12px 16px; margin-bottom: 14px; }
.preview-loading { display: flex; align-items: center; gap: 8px; color: #495057; font-size: 0.85rem; }
.preview-title { font-size: 0.8rem; font-weight: 700; color: #0550ae; margin-bottom: 10px; display: flex; align-items: center; gap: 6px; }
.preview-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; }
.preview-item { display: flex; flex-direction: column; gap: 2px; }
.preview-item span { font-size: 0.72rem; color: #6c757d; }
.preview-item strong { font-size: 0.95rem; color: #212529; }
.preview-item--total { background: #e8f0ff; border-radius: 8px; padding: 6px 10px; }
.preview-item--total strong { color: #0550ae; }

/* ── Diferencia preview ── */
.diferencia-preview { display: flex; align-items: center; justify-content: space-between; padding: 10px 16px; border-radius: 10px; margin-top: 10px; border: 1px solid; }
.diferencia-preview span { font-size: 0.85rem; font-weight: 600; }
.diferencia-preview strong { font-size: 1rem; font-weight: 700; }
.dif-danger { background: #fff5f5; border-color: #f1aeb5; color: #842029; }
.dif-warning { background: #fffde7; border-color: #ffe082; color: #856404; }
.dif-success { background: #f0fff4; border-color: #a3cfbb; color: #0f5132; }

/* ── Denominations ── */
.denom-title { font-size: 0.875rem; font-weight: 700; color: #c09d62; margin: 8px 0 12px; border-bottom: 1px solid #dee2e6; padding-bottom: 8px; }
.denominaciones-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 12px; }
.denom-section h4 { font-size: 0.8rem; font-weight: 700; color: #c09d62; margin: 0 0 8px; display: flex; align-items: center; gap: 6px; }
.denom-row { display: grid; grid-template-columns: 70px 1fr 80px; align-items: center; gap: 6px; margin-bottom: 6px; }
.denom-label { font-size: 0.8rem; font-weight: 600; color: #495057; }
.input-denom { padding: 5px 8px; border-radius: 8px; border: 1px solid #ced4da; font-size: 0.8rem; width: 100%; text-align: right; font-family: "Montserrat", sans-serif; background: white; color: #212529; }
.input-denom:focus { border-color: #c09d62; box-shadow: 0 0 0 2px rgba(192,157,98,0.2); outline: none; }
.denom-sub { font-size: 0.72rem; color: #6c757d; text-align: right; white-space: nowrap; }

/* ── Totals box ── */
.total-contado-box { display: flex; align-items: center; justify-content: space-between; background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 10px; padding: 12px 16px; margin-top: 4px; }
.total-contado-box span { font-size: 0.9rem; font-weight: 600; color: #495057; }
.total-num { font-size: 1.25rem; font-weight: 700; color: #212529; }

/* ── Detalle modal ── */
.info-row { display: flex; gap: 16px; flex-wrap: wrap; background: #f8f9fa; border-radius: 8px; padding: 10px 14px; margin-bottom: 12px; font-size: 0.85rem; color: #6c757d; border: 1px solid #e2e8f0; }
.info-row span strong { color: #212529; }
.result-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 10px; margin-bottom: 12px; }
.result-card { background: #f8f9fa; border: 1px solid #e2e8f0; border-radius: 10px; padding: 12px; display: flex; flex-direction: column; gap: 4px; }
.result-card span { font-size: 0.72rem; color: #6c757d; }
.result-card strong { font-size: 1rem; font-weight: 700; color: #212529; }
.result-card.card-danger { background: #fff5f5; border-color: #f1aeb5; }
.result-card.card-danger strong { color: #842029; }
.result-card.card-warning { background: #fffde7; border-color: #ffe082; }
.result-card.card-warning strong { color: #856404; }
.result-card.card-success { background: #f0fff4; border-color: #a3cfbb; }
.result-card.card-success strong { color: #0f5132; }
.notas-box { background: #fffde7; border: 1px solid #ffe082; border-radius: 8px; padding: 10px 14px; font-size: 0.85rem; color: #212529; }
.anulaciones-box { margin-top: 12px; border: 1px solid #f5c2c7; border-radius: 8px; overflow: hidden; }
.anulaciones-header { background: #f8d7da; color: #842029; font-size: 0.82rem; font-weight: 700; padding: 7px 12px; display: flex; align-items: center; gap: 6px; }
.anulaciones-table { width: 100%; border-collapse: collapse; font-size: 0.8rem; }
.anulaciones-table th { background: #fff5f5; color: #842029; font-weight: 600; padding: 5px 10px; text-align: left; border-bottom: 1px solid #f5c2c7; }
.anulaciones-table td { padding: 5px 10px; border-bottom: 1px solid #f8d7da; color: #212529; }
.anulaciones-table tr:last-child td { border-bottom: none; }
.anulaciones-table .text-danger { color: #842029; }
.anulaciones-table .small { font-size: 0.75rem; color: #6c757d; }

@media (max-width: 640px) {
  .form-row, .denominaciones-grid, .preview-grid { grid-template-columns: 1fr; }
  .page-header { flex-direction: column; align-items: stretch; }

  /* Card view para tabla de arqueos */
  .data-table thead { display: none; }
  .data-table, .data-table tbody { display: block; }
  .data-table tr {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2px 8px;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    padding: 10px 12px;
    margin-bottom: 10px;
    background: #fff;
  }
  .data-table td {
    display: flex;
    flex-direction: column;
    font-size: 13px;
    border: none !important;
    padding: 4px 0;
  }
  .data-table td::before {
    content: attr(data-label);
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    color: #888;
    letter-spacing: .4px;
    margin-bottom: 2px;
  }
  /* Período ocupa todo el ancho */
  .data-table td:first-child { grid-column: 1 / -1; font-weight: 600; }
  /* Botón ver al final */
  .data-table td:last-child { grid-column: 1 / -1; align-items: flex-end; }
}

/* ── Dark Mode ── */
.dark .page-container { background: #1e1e1e; color: #e5e5e5; }
.dark .page-header h1 { color: #e5e5e5; }
.dark .subtitle { color: #9e9e9e; }
.dark .form-input, .dark .busqueda { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }

/* Paginación */
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 8px;
}
.pagination-info { font-size: 0.85rem; color: #6c757d; }
.pagination-container { display: flex; gap: 8px; }
.pagination-button {
  padding: 6px 14px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: white;
  color: #495057;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 40px;
}
.pagination-button:hover:not(:disabled) { background: #c09d62; color: white; border-color: #c09d62; }
.pagination-button:disabled { opacity: 0.5; cursor: not-allowed; }
.dark .pagination-wrapper { border-color: #404040; }
.dark .pagination-info { color: #aaaaaa; }
.dark .pagination-button { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .pagination-button:hover:not(:disabled) { background: #c09d62; border-color: #c09d62; }
.dark .form-select, .dark select { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .form-textarea { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .input-denom { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .table-container { border-color: #404040; }
.dark .data-table th { background: #2d2d2d; color: #9e9e9e; border-color: #404040; }
.dark .data-table td { background: #1e1e1e; color: #e5e5e5; border-color: #404040; }
.dark .data-table tbody tr:hover td { background: #2d2d2d; }
@media (max-width: 640px) {
  .dark .data-table tr { background: #2d2d2d; border-color: #404040; }
  .dark .data-table td::before { color: #666; }
}
.dark .accion-btn { opacity: 0.9; }
.dark .btn-close-x { color: #9e9e9e; }
.dark .btn-close-x:hover { color: #e5e5e5; background: #3d3d3d; }
.dark .form-group label { color: #9e9e9e; }
.dark .modal-box { background: #1e1e1e; }
.dark .modal-header { background: #2d2d2d; border-color: #404040; }
.dark .modal-header h2 { color: #e5e5e5; }
.dark .modal-body { background: #1e1e1e; }
.dark .modal-footer { background: #2d2d2d; border-color: #404040; }
.dark .empty-state { color: #9e9e9e; }
.dark .denom-title { color: #c09d62; border-color: #404040; }
.dark .denom-section h4 { color: #c09d62; }
.dark .denom-label { color: #9e9e9e; }
.dark .denom-sub { color: #6c757d; }
.dark .total-contado-box { background: #2d2d2d; border-color: #404040; color: #e5e5e5; }
.dark .total-num { color: #e5e5e5; }
.dark .result-card { background: #2d2d2d; border-color: #404040; }
.dark .result-card span { color: #9e9e9e; }
.dark .result-card strong { color: #e5e5e5; }
.dark .result-card.card-danger { background: #3d1515; border-color: #842029; }
.dark .result-card.card-danger strong { color: #f5c2c7; }
.dark .result-card.card-warning { background: #2a2215; border-color: #856404; }
.dark .result-card.card-warning strong { color: #ffe082; }
.dark .result-card.card-success { background: #0f1f15; border-color: #0f5132; }
.dark .result-card.card-success strong { color: #a3cfbb; }
.dark .info-row { background: #2d2d2d; border-color: #404040; color: #9e9e9e; }
.dark .info-row span strong { color: #e5e5e5; }
.dark .notas-box { background: #2a2215; border-color: #4a3d1a; color: #e5e5e5; }
.dark .anulaciones-box { border-color: #842029; }
.dark .anulaciones-header { background: #3d1515; color: #f5c2c7; }
.dark .anulaciones-table th { background: #2d1010; color: #f5c2c7; border-color: #842029; }
.dark .anulaciones-table td { color: #e5e5e5; border-color: #3d1515; }
.dark .anulaciones-table .text-danger { color: #f5c2c7; }
.dark .anulaciones-table .small { color: #aaa; }
.dark .sistema-preview { background: #1a2340; border-color: #2a4070; }
.dark .preview-title { color: #6ea8fe; }
.dark .preview-item span { color: #9e9e9e; }
.dark .preview-item strong { color: #e5e5e5; }
.dark .preview-item--total { background: #1e2d50; }
.dark .preview-item--total strong { color: #6ea8fe; }
.dark .diferencia-preview.dif-danger { background: #3d1515; border-color: #842029; color: #f5c2c7; }
.dark .diferencia-preview.dif-warning { background: #2a2215; border-color: #856404; color: #ffe082; }
.dark .diferencia-preview.dif-success { background: #0f1f15; border-color: #0f5132; color: #a3cfbb; }
.dark .hint-text { color: #6c757d; }
</style>
